/**
 * Collection Filters Toggle
 * Handles show/hide filters functionality with section rendering support
 */

class CollectionFiltersToggle {
  constructor() {
    this.container = document.getElementById('CollectionFiltersContainer');
    
    if (!this.container) return;
    
    this.init();
    this.bindEvents();
    this.observeSectionRendering();
  }

  get showBtn() {
    return document.querySelector('.show-filters-btn');
  }

  get hideBtn() {
    return document.querySelector('.hide-filters-btn');
  }

  get isHidden() {
    return localStorage.getItem('filtersHidden') === 'true';
  }

  init() {
    if (this.isHidden) {
      this.hideFilters();
    }
  }

  bindEvents() {
    // Use event delegation to handle dynamic elements
    document.addEventListener('click', (e) => {
      if (e.target.closest('.show-filters-btn')) {
        e.preventDefault();
        this.showFilters();
      }
      
      if (e.target.closest('.hide-filters-btn')) {
        e.preventDefault();
        this.hideFilters();
      }
    });
  }

  hideFilters() {
    this.container.classList.add('filters-hidden');
    this.updateShowButton(true);
    localStorage.setItem('filtersHidden', 'true');
  }

  showFilters() {
    this.container.classList.remove('filters-hidden');
    this.updateShowButton(false);
    localStorage.setItem('filtersHidden', 'false');
  }

  updateShowButton(show) {
    const btn = this.showBtn;
    if (btn) {
      if (show) {
        btn.classList.remove('hidden');
        btn.classList.add('flex');
      } else {
        btn.classList.add('hidden');
        btn.classList.remove('flex');
      }
    }
  }

  // Re-apply state after section rendering updates the DOM
  observeSectionRendering() {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) return;

    const observer = new MutationObserver(() => {
      // Re-apply filter state after DOM changes
      if (this.isHidden) {
        this.container.classList.add('filters-hidden');
        this.updateShowButton(true);
      }
    });

    observer.observe(productGridContainer, { 
      childList: true, 
      subtree: false 
    });
  }

  
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  new CollectionFiltersToggle();
});